import * as React from 'react';

export const PopupPageContext = React.createContext<{
  onOverlayClick?: () => void;
}>({});
